export default {
    tripCover() {
        if (this.trip && this.trip.cover && !this.trip.cover.match(/base64/g)) {
            const baseUrl = process.env.VUE_APP_BASE_URL

            return `${baseUrl}/assets/img/fb_imgs/${this.trip.cover}`
        }

        if (this.trip && this.trip.cover && this.trip.cover.match(/base64/g)) {
            return this.trip.cover
        }
    },

    videoPreview() {
        return this.trip.videoId ? `http://i3.ytimg.com/vi/${this.trip.videoId}/hqdefault.jpg` : null
    },

    cropperAspectRatio() {
        let ratio = 1

        if (this.croppingModel === 'cover') {
            ratio = 750/422
        }

        if (this.croppingModel === 'gallery') {
            ratio = 1.85
        }

        return ratio
    }
}
